import styled from 'styled-components/macro'

export const Container = styled.div`
  fill: ${(props) => (props.$isHealthy ? '#00ba86' : 'red')};
`
